/**
 * Dlaždica Dune na portáli — plná verzia 1.0: celá základná hra so
 * spojenectvami a všetkými kartami, hot-seat, online aj proti botom. Obal je
 * obrázok z krabice od používateľa (`public/art/dune/cover.webp`).
 */

import { useEffect } from 'react';

import { GameCard } from '../../portal/GameCard.js';
import { loadDuneFonts } from './art.js';
import type { PortalTileProps } from '../registry.js';

export function DuneTile({ navigate }: PortalTileProps) {
  // Názov v písme Dune (Space Mono) — jej fonty sa inak načítajú až v module hry.
  useEffect(loadDuneFonts, []);
  return (
    <GameCard
      title="Dune: Board Game"
      status="live"
      badge="Plná verzia 1.0"
      titleStyle={{ fontFamily: "'Space Mono', monospace", fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}
      players="2–6 hráčov"
      duration="2–3 h"
      tags={['Stratégia', 'Vyjednávanie', 'Zrada', 'Aj proti botom']}
      description="Politika, zrada a boj o Arrakis a korenie. Celá základná hra podľa pravidiel GF9 — spojenectvá, všetky karty, šesť frakcií, online aj proti botom."
      onPlay={() => navigate('#/dune')}
      cover={
        <span className="libCover libCover--dune">
          <img className="libCover__img" src="/art/dune/cover.webp" alt="Dune" draggable={false} />
        </span>
      }
    />
  );
}
